import { type EventMappers, registerGa4Events } from '../../tracking/dataLayerAdapter';

declare module '@platform/tracking' {
  interface TrackingEvents {
    devices_viewed: { device_count: number; device_limit: number };
    device_remove_started: { device_count: number; device_type: string; platform: string };
    device_remove_confirmed: { device_count: number; device_type: string; platform: string };
    device_remove_aborted: Record<string, never>;
    device_remove_all_started: { device_count: number };
    device_remove_all_confirmed: { device_count: number };
    device_remove_all_aborted: Record<string, never>;
    /** Internal-only, not sent to GA4 (see mappers below). */
    device_remove_failed: { device_count: number; device_type: string; platform: string; error_code: string };
    device_remove_all_failed: { device_count: number; error_code: string };
  }
}

export const deviceGa4EventMappers: EventMappers = {
  devices_viewed: (p) => ({
    event: 'device_management',
    event_description: 'devices_viewed',
    device_count: p.device_count,
    device_limit: p.device_limit,
  }),
  // device_type/platform stay out of the GA4 payload on purpose (internal-only context).
  device_remove_started: (p) => ({
    event: 'device_management',
    event_description: 'device_remove_started',
    device_count: p.device_count,
  }),
  device_remove_confirmed: (p) => ({
    event: 'device_management',
    event_description: 'device_remove_confirmed',
    device_count: p.device_count,
  }),
  device_remove_aborted: () => ({ event: 'device_management', event_description: 'device_remove_aborted' }),
  device_remove_all_started: (p) => ({
    event: 'device_management',
    event_description: 'device_remove_all_started',
    device_count: p.device_count,
  }),
  device_remove_all_confirmed: (p) => ({
    event: 'device_management',
    event_description: 'device_remove_all_confirmed',
    device_count: p.device_count,
  }),
  device_remove_all_aborted: () => ({ event: 'device_management', event_description: 'device_remove_all_aborted' }),
  // `null` suppresses the GA4 push; the params still reach /collect regardless.
  device_remove_failed: () => null,
  device_remove_all_failed: () => null,
};

registerGa4Events(deviceGa4EventMappers);
